import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';

const PrivateRoute = ({children}) => {
    const {user, loading} = useAuth();

    if (!user) {
        if (loading) {
            // En cours de chargement de l'authentification
            return <div>Loading...</div>;
        } else {
            // Pas connecté ? Redirection vers Login
            return <Navigate to="/login"/>;
        }
    }

    // Connecté ? On affiche la page demandée (le Dashboard par exemple)
    return children;
};

export default PrivateRoute;